import { useMemo } from "react";
// import { useEffect, useRef, useState } from "react";
// import { useDispatch } from "react-redux";
// import { forecastersEndPointLogic } from '../logic/AssetManagement/Forecasters/forecastersEndPointLogic';
// import { setDisplayErrorSnackBar } from '../features/userSlice';
import { useSelector } from "react-redux";

// const QUERY_ID = "5671636300726272"; // Deviation query — disabled to remove 12 per-month API calls

// Complete mapping: metric name (as used in getActual calls) → field name in the
// flat entries returned by query 5699409840963584.
// All Actual values come from the new query; Deviation is kept from the old query.
const ALL_METRICS: { Metric: string; field: string }[] = [
  { Metric: "nrpu",                         field: "nrpu" },
  { Metric: "growth",                        field: "growth" },
  { Metric: "avg_net_rev_per_active_user",   field: "avg_net_rev_per_active_user" },
  { Metric: "cpa_pv",                        field: "cpa_pv" },
  { Metric: "CVR",                           field: "CVR" },
  { Metric: "profit",                        field: "profit" },
  { Metric: "active_users",                  field: "active_users" },
  { Metric: "old_active_users",              field: "old" },
  { Metric: "acquired_active_users",         field: "aquired" },
  { Metric: "ftd",                           field: "ftd" },
  { Metric: "net_rev",                       field: "net_rev" },
  { Metric: "rs_pv",                         field: "rs_pv" },
  { Metric: "rs_income_dollar",              field: "rs_income_dollar" },
  { Metric: "total_income",                  field: "total_income" },
  { Metric: "clicks",                        field: "clicks" },
  { Metric: "EPC_CPA",                       field: "EPC_CPA" },
  { Metric: "EPC_RS",                        field: "EPC_RS" },
  { Metric: "EPC",                           field: "EPC" },
  { Metric: "CPC",                           field: "CPC" },
  { Metric: "CAC",                           field: "CAC" },
  { Metric: "spend",                         field: "spend" },
  { Metric: "avg_rs_p",                      field: "avg_rs_p" },
  { Metric: "churn_rate",                    field: "churn_rate" },
  { Metric: "rs_br_ng",                      field: "rs_br_ng" },
  { Metric: "Ratio_between_acquired_to_ftd", field: "Ratio_between_acquired_to_ftd" },
];

// rowMonth is "YYYY-MM"; new query entries are "YYYY-MM-DD" or "YYYY-MM-DD - RR".
// For the current month always prefer the "RR" (Rolling Real) entry.
const findLastDataEntry = (allMonthsData: any[], rowMonth: string) => {
  const [year, month] = rowMonth.split("-").map(Number);
  const today = new Date();
  const isCurrentMonth =
    year === today.getFullYear() && month === today.getMonth() + 1;
  const prefix = `${year}-${String(month).padStart(2, "0")}-`;

  if (isCurrentMonth) {
    return (
      allMonthsData.find(
        (e: any) => e.month?.startsWith(prefix) && e.month.includes("RR"),
      ) ?? allMonthsData.find((e: any) => e.month?.startsWith(prefix))
    );
  }
  return allMonthsData.find(
    (e: any) => e.month?.startsWith(prefix) && !e.month.includes("RR"),
  );
};

// Build the enriched query_output:
// - Actual for every metric comes from the new query (5699409840963584)
// - Deviation disabled: re-enable by restoring the old query fetch below
const buildEnrichedQueryOutput = (lastEntry: any) => {
  return ALL_METRICS.map(({ Metric, field }) => ({
    Metric,
    Actual: lastEntry ? lastEntry[field] ?? null : null,
    Deviation: null, // Deviation disabled — restore from old query when re-enabling
  }));
};

// DEVIATION FETCH DISABLED — restore this block to re-enable the 12 per-month API calls
// const buildEnrichedQueryOutputWithDeviation = (oldQueryOutput: any[], lastEntry: any) => {
//   const oldByMetric: Record<string, any> = {};
//   for (const m of oldQueryOutput || []) {
//     if (m?.Metric) oldByMetric[m.Metric.toLowerCase()] = m;
//   }
//   return ALL_METRICS.map(({ Metric, field }) => {
//     const oldEntry = oldByMetric[Metric.toLowerCase()];
//     return {
//       Metric,
//       Actual: lastEntry ? lastEntry[field] ?? null : null,
//       Deviation: oldEntry?.Deviation ?? null,
//     };
//   });
// };

export const usePastForecast = (
  modifiedRows: any,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _oauthTokenHeader: any,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _selectedSite: any,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _enabled: boolean = true,
) => {
  // DEVIATION FETCH DISABLED — restore the block below to re-enable
  // const dispatch = useDispatch();
  // const [loading, setLoading] = useState(false) as any;
  // const [initialized, setInitialized] = useState(false);
  // const hasFetchedRef = useRef(false);
  // const [deviationResults, setDeviationResults] = useState<any[]>([]);

  const forecastLastTwelveMonthsData = useSelector(
    (state: any) => state?.forecasters?.forecastLastTwelveMonthsData,
  );

  // DEVIATION FETCH DISABLED — restore this useEffect to re-enable
  // useEffect(() => {
  //   if (!enabled) return;
  //   if (hasFetchedRef.current) return;
  //   const rows = modifiedRows ?? [];
  //   const uids = rows.map((row: any) => row.content_shared_uid);
  //   const dates = rows.map((row: any) => row.month);
  //   const fetchDeviationData = async () => {
  //     try {
  //       setLoading(true);
  //       const promises = uids.map((uid: any, index: any) =>
  //         forecastersEndPointLogic.getDeviationData(_oauthTokenHeader, QUERY_ID, _selectedSite, dates[index], uid));
  //       const results = await Promise.all(promises);
  //       setDeviationResults(results);
  //     } catch (error: any) {
  //       dispatch(setDisplayErrorSnackBar({ message: error.message, severity: "error" }));
  //     } finally {
  //       setLoading(false);
  //       setInitialized(true);
  //     }
  //   };
  //   hasFetchedRef.current = true;
  //   if (uids.length > 0) {
  //     fetchDeviationData();
  //   } else {
  //     setInitialized(true);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [_enabled, modifiedRows?.length ?? 0]);

  const forecastData = useMemo(() => {
    if (!modifiedRows?.length) return [];
    const allMonthsData = forecastLastTwelveMonthsData?.query_output || [];

    return modifiedRows.map((row: any) => {
      const lastEntry = findLastDataEntry(allMonthsData, row.month);
      return {
        query_output: buildEnrichedQueryOutput(lastEntry),
        content_shared_uid: row.content_shared_uid,
        month: row.month,
        displayMonth: row.displayMonth,
      };
    });

    // DEVIATION FETCH DISABLED — when re-enabling, replace the map above with:
    // return deviationResults.map((item, index) => {
    //   const rowMonth = modifiedRows[index]?.month;
    //   const lastEntry = findLastDataEntry(allMonthsData, rowMonth);
    //   return {
    //     ...item,
    //     query_output: buildEnrichedQueryOutputWithDeviation(item?.query_output, lastEntry),
    //     content_shared_uid: modifiedRows[index]?.content_shared_uid,
    //     month: rowMonth,
    //     displayMonth: modifiedRows[index]?.displayMonth,
    //   };
    // });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modifiedRows, forecastLastTwelveMonthsData]);

  return { forecastData, loading: false, initialized: true };
  // DEVIATION FETCH DISABLED — when re-enabling, restore:
  // return { forecastData, loading, initialized };
};
